import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { lenis } from "./main.js";

document.addEventListener("DOMContentLoaded", () => {
  const animationClass = "animate";

  const wowContainers = document.querySelectorAll(".wowCont");
  const allWowElements = document.querySelectorAll(".wow:not(.boldNav)");
  const containerWows = new Set();
  document
    .querySelectorAll(".wowCont .wow:not(.boldNav)")
    .forEach((el) => containerWows.add(el));
  const standaloneWows = Array.from(allWowElements).filter(
    (el) => !containerWows.has(el)
  );

  const shouldRunWow = wowContainers.length > 0 || standaloneWows.length > 0;

  if (shouldRunWow) {
    const getScrollTop = () => {
      return lenis ? lenis.scroll : window.scrollY;
    };

    const runWowContainers = () => {
      const viewportHeight = window.innerHeight;
      const scrollTop = getScrollTop();

      wowContainers.forEach((container) => {
        const wowElements = container.querySelectorAll(".wow:not(.boldNav)");
        const containerRect = container.getBoundingClientRect();
        const containerTop = containerRect.top + scrollTop;
        const containerHeight = containerRect.height;
        const containerBottom = containerTop + containerHeight;
        const viewportBottom = scrollTop + viewportHeight;

        const isFullyInView =
          containerTop < viewportBottom && containerBottom > scrollTop;
        const isFullyOutOfView =
          containerBottom <= scrollTop || containerTop >= viewportBottom;

        if (isFullyInView) {
          wowElements.forEach((el, index) => {
            const delay = index * 300;
            setTimeout(() => el.classList.add(animationClass), delay);
          });
        } else if (isFullyOutOfView) {
          wowElements.forEach((el) => {
            el.classList.remove(animationClass);
          });
        }
      });
    };

    const runStandaloneWows = () => {
      const viewportHeight = window.innerHeight;
      const scrollTop = getScrollTop();

      standaloneWows.forEach((el) => {
        const elRect = el.getBoundingClientRect();
        const elTop = elRect.top + scrollTop;
        const elMiddle = elRect.height / 2;

        const isElementVisible =
          elTop + elMiddle <= scrollTop + viewportHeight &&
          elTop + elMiddle >= scrollTop;

        if (isElementVisible) {
          el.classList.add(animationClass);
        } else {
          el.classList.remove(animationClass);
        }
      });
    };

    const handleScrollResize = () => {
      if (wowContainers.length) runWowContainers();
      if (standaloneWows.length) runStandaloneWows();
    };

    if (lenis) {
      lenis.on("scroll", handleScrollResize);
    } else {
      window.addEventListener("scroll", handleScrollResize);
    }

    window.addEventListener("resize", handleScrollResize);
    handleScrollResize(); // initial check
  }

  gsap.registerPlugin(ScrollTrigger);

  // Animate hero only if the trigger and target elements exist
  const heroContainer = document.querySelector(".hero-container");
  const heroContent = document.querySelector(".hero-content");
  const lines = document.querySelector(".lines");

  if (window.innerWidth >= 450 && heroContainer && heroContent) {
    gsap.to(heroContent, {
      scale: window.innerWidth >= 768 ? 1.4 : 0.8,
      ease: "none",
      scrollTrigger: {
        trigger: heroContainer,
        start: "top top",
        end: "+=600",
        scrub: 1,
        pin: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
      },
    });
  }

  if (heroContainer && lines) {
    gsap.to(lines, {
      y: 250,
      ease: "none",
      scrollTrigger: {
        trigger: heroContainer,
        start: "top top",
        end: "+=1000",
        scrub: 1,
        invalidateOnRefresh: true,
      },
    });
  }

  // Parallax animation only if elements are found
  const parallaxElements = document.querySelectorAll(".parallax-img");
  if (window.innerWidth >= 768 && parallaxElements.length > 0) {
    parallaxElements.forEach((el) => {
      gsap.to(el, {
        yPercent: 10,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          end: "bottom top",
          scrub: 1,
          invalidateOnRefresh: true,
        },
      });
    });
  }

  // Ensure ScrollTrigger refreshes after Lenis resize
  if (lenis) {
    lenis.on("resize", () => {
      ScrollTrigger.refresh();
    });
  }
});
